module.exports = __webpack_public_path__ + "img/bg.c294f1dc.jpg";